export default () => {
	const alertContainer = document.getElementById("alerts-container");
	if (!alertContainer) return;

	// Get all alert bars
	const alertBars = alertContainer.querySelectorAll('.alert-bar');
	
	alertBars.forEach(alertBar => {
		const alertId = alertBar.dataset.alertId;
		const closeBtn = alertBar.querySelector('.alert-bar__close-btn');
		
		// Check if this alert was previously closed
		const storageKey = `hcls-alert-${alertId}`;
		if (localStorage.getItem(storageKey) === "closed") {
			alertBar.remove();
			return;
		}

		// Show the alert
		alertBar.classList.remove('d-none');

		// Handle close button
		closeBtn?.addEventListener("click", () => {
			alertBar.remove();
			localStorage.setItem(storageKey, "closed");
		});
	});
}
